/* eslint-disable no-param-reassign */
export const supportedElements = [
    'a',
    'p',
    'span',
    'ol',
    'ul',
    'li',
    'h1',
    'h2',
    'h3',
    'strong',
    'em',
    'br',
    'sub',
    'sup',
    'div',
    'text',
    'body',
    'b',
    'u',
    'i',
];

const supportedAttributes = ['dir', 'style', 'title', 'href'];

const supportedStyles = [
    'text-decoration',
    'text-decoration-line',
    'color',
    'background-color',
];

const _removeUnsupportedStyle = (node) => {
    const styleArray = node.style.cssText.split('; ');
    styleArray.forEach((style) => {
        if (style.split(':')[0].trim() === 'text-decoration' && style.split(':')[1].trim() === 'underline') {
            const underline = document.createElement('ins');
            underline.innerHTML = node.innerHTML;
            node.innerHTML = '';
            node.appendChild(underline);
        }
        if (style.split(':')[0].trim() === 'font-style' && style.split(':')[1].trim() === 'italic') {
            const underline = document.createElement('em');
            underline.innerHTML = node.innerHTML;
            node.innerHTML = '';
            node.appendChild(underline);
        }
    });
    const newStyleArray = styleArray.filter((element) => supportedStyles.includes(element.split(':')[0].trim()));
    let newSyleString = newStyleArray.join(';');
    newSyleString = newSyleString.slice(0, -1);
    node.setAttribute('style', newSyleString);
};


export const removeUnsupportedElements = (html, tag) => {
    const tagNode = html.getElementsByTagName(tag);
    const tagCounts = tagNode.length;

    for (let i = 0; i < tagCounts; i++) {
        if (tagNode[0]) {
            tagNode[0].parentNode.removeChild(tagNode[0]);
        }
    }

    return html;
};

export const removeUnsupportedAttributes = (html, tag) => {
    const tagNode = html.getElementsByTagName(tag);
    // DraftJS adds em, ins and strong. For Italic, underline and Bold, hence we have to manually add these tags if any of them was detected
    tagNode.forEach((node) => {
        if (tag === 'i') {
            const italic = document.createElement('em');
            italic.innerHTML = node.innerHTML;
            node.innerHTML = '';
            node.appendChild(italic);
        } else if (tag === 'u') {
            const underline = document.createElement('ins');
            underline.innerHTML = node.innerHTML;
            node.innerHTML = '';
            node.appendChild(underline);
        } else if (tag === 'b') {
            const bold = document.createElement('strong');
            bold.innerHTML = node.innerHTML;
            node.innerHTML = '';
            node.appendChild(bold);
        }
        const attributesArray = Array.prototype.slice.call(node.attributes);
        attributesArray.forEach((attribute) => {
            if (!supportedAttributes.includes(attribute.name)) {
                node.removeAttribute(attribute.name);
            }
            if (attribute.name === 'style' && node.style.cssText != null) {
                _removeUnsupportedStyle(node);
            }
        });
    });
};
